'use strict';

/** @type {import('.')} */
module.exports = Error;



// WEBPACK FOOTER //
// ./~/es-errors/index.js